import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MainComponent } from '../app/client/pages/main/main.component';
import { ClientModule} from '../../src/app/client/client-module'
import { AdminModule } from '../../src/app/admin/admin-module';
const routes: Routes = [

  {
    path: '',
    loadChildren: () => import('../../src/app/client/client-module').then(m => m.ClientModule),
 
  },

  {
    path: 'admin',
    loadChildren: () => import('../../src/app/admin/admin-module').then(m => m.AdminModule),
    //canActivateChild: [AuthenticationGuard]
  },


];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
